var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.coordinates)?_c('GmapMap',{staticClass:"fluid-wrapper",attrs:{"center":_vm.coordinates,"zoom":13}},[_c('GmapMarker',{attrs:{"position":_vm.coordinates}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }